module.exports = __webpack_public_path__ + "img/bf／pic.9a07fd68.png";